import get from 'lodash/get'

export const getColorFromBg = bg => props => {
  return `${get(props.theme, bg ? `colors.${bg}` : 'colors.primary')}`
}
